import * as React from 'react';
import { UitkCardTextSegment } from 'uitk-react-cards';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { Airline } from 'components/shared';
import { useStores } from 'utility/hooks';

interface InfoHeaderProps {
  itemIndex?: number;
}

export const InfoHeader = (props: InfoHeaderProps) => {
  const { flightsSelectedJourneyReviewStore } = useStores();
  const { itemIndex } = props;

  if (
    flightsSelectedJourneyReviewStore &&
    itemIndex !== undefined &&
    flightsSelectedJourneyReviewStore.flightsSelectedJourneyReviewItem(itemIndex)
  ) {
    // todo this should be removed once sidesheet starts passing values in the components in FSR flow
    const {
      heading,
      flightsJourneySubheadingImage,
      flightsJourneySubheading
    } = flightsSelectedJourneyReviewStore.flightsSelectedJourneyReviewItem(itemIndex).flightsJourneyHeaders;

    // TODO once this is done https://jira.expedia.biz/browse/UDS-2248 we can remove UitkText
    return (
      <UitkSpacing margin={{ blockend: 'three' }}>
        <UitkCardTextSegment data-test-id="flight-review-header">
          <div className="all-x-padding-three all-t-padding-three">
            <UitkHeading level={2} size={600}>
              {heading}
            </UitkHeading>
            <UitkSubheading>
              <UitkText spacing="one">
                {(flightsJourneySubheadingImage && (
                  <Airline logo={flightsJourneySubheadingImage} name={flightsJourneySubheading} />
                )) ||
                  flightsJourneySubheading}
              </UitkText>
            </UitkSubheading>
          </div>
        </UitkCardTextSegment>
      </UitkSpacing>
    );
  }

  return null;
};
